import React from "react";
import { Scatter } from "react-chartjs-2";
import { Chart } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

Chart.register(annotationPlugin);

const ScatterChart = ({ dataSet }) => {
	console.log('data === ', dataSet)
	let rerata = []
	let ensa = 0
	let wil = 0
	if (dataSet != null) {
		ensa = dataSet.ensa
		wil = dataSet.wil
		for (let i in dataSet.rerataSekolah) {
			const rata = dataSet.rerataSekolah[i]
			const data = new Object()
			data.x = rata.value
			data.y = i + 1
			rerata.push(data)
		}
	}



	//! Template Datanya seperti ini
	// const dataset = [
	// 	{ x: 0.1, y: 1 },
	// 	{ x: 1.4, y: 2 },
	// 	{ x: 2.4, y: 3 },
	// 	{ x: 2.6, y: 4 },
	// ];

	// Ini hanya data redom aja
	const elementSample = 10;
	const getRandomFloat = (min, max) => Math.random() * (max - min) + min;
	// const dataset = Array.from({ length: elementSample }, (v, index) => ({
	// 	x: getRandomFloat(0.0, 3.0),
	// 	y: index + 1, // Ngatur y seko 1 tekan jumlah elemen
	// }));
	const dataset = rerata;

	const xOpt = {
		scales: {
			y: {
				ticks: {
					display: false,
				},
			},
		},
		plugins: {
			legend: {
				display: false,
			},
			annotation: {
				annotations: {
					line1: {
						type: "line",
						xMin: wil,
						xMax: wil,
						label: {
							enabled: true,
							content: "WIL",
							position: "end",
							borderRadius: 0,
							backgroundColor: "black",
						},
						borderColor: "black",
						borderWidth: 3,
					},
					line2: {
						type: "line",
						xMin: ensa,
						xMax: ensa,
						label: {
							enabled: true,
							content: "ENSA",
							position: "enda",
							borderRadius: 0,
							backgroundColor: "green",
						},
						borderColor: "green",
						borderWidth: 3,
					},
				},
			},
		},
	};

	const data = {
		datasets: [
			{
				pointRadius: 10,
				pointBackgroundColor: "#FF3838",
				pointStyle: "rectRot",
				data: dataset,
			},
		],
	};

	return <Scatter data={data} options={xOpt} width={100} height={90} />;
};

export default ScatterChart;
